import { findKey, mapKeys } from "lodash";
import { ANALYSIS_CLASSIFICATION } from "../../consts";

const prepareVmRayResult = data => {
  if (!data.length) return null;

  const vmrayResultKey = findKey(
    data,
    o => o.key === "submission_sample_verdict"
  );
  const vmrayErrorKey = findKey(data, o => o.key === "submission_status");

  if (vmrayResultKey) {
    return data[vmrayResultKey]?.value === "clean"
      ? ANALYSIS_CLASSIFICATION.GOODWARE
      : data[vmrayResultKey]?.value;
  }

  if (vmrayErrorKey) return "Analysis failed";
  return null;
};

export { prepareVmRayResult };
